/* CHARÉE — Maison · light.js
   The light of the page. One small WebGL2 fragment shader draws slow water-light on Crème; its colour follows
   the visitor's hour (dawn to dusk, never night) and the chapter she is reading. Nothing is loaded from outside,
   nothing is stored. Without WebGL2 the CSS light stays; with reduced motion the light stands still. */
(function () {
  'use strict';
  var canvas = document.querySelector('.light__canvas');
  if (!canvas || !window.WebGL2RenderingContext) { return; }
  var holder = canvas.parentNode;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var gl = canvas.getContext('webgl2', { alpha: false, antialias: false, depth: false, stencil: false, powerPreference: 'low-power', preserveDrawingBuffer: false });
  if (!gl) { return; }

  var VS = '#version 300 es\nin vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
  var FS = '#version 300 es\nprecision highp float;out vec4 o;uniform vec2 r;uniform float t;uniform float m;uniform float g;uniform vec2 u;' +
    'float h(vec2 p){vec3 q=fract(vec3(p.xyx)*.1031);q+=dot(q,q.yzx+33.33);return fract((q.x+q.y)*q.z);}' +
    'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),f.x),f.y);}' +
    'float fb(vec2 p){float v=0.,a=.5;for(int k=0;k<3;k++){v+=a*n(p);p=p*2.03+vec2(1.7,9.2);a*=.5;}return v;}' +
    'void main(){vec2 uv=gl_FragCoord.xy/r;float ar=r.x/r.y;vec2 p=vec2(uv.x*ar,uv.y);float s=t*.028;' +
    'vec2 q=vec2(fb(p*.9+s),fb(p*.9-s*.8+3.1));float k=fb(p*1.3+1.4*q+vec2(s*.6,-s*.4));' +
    'float rd=1.-abs(2.*k-1.);rd=pow(rd,3.0);' +
    'vec2 sp=mix(vec2(.66,.74),vec2(.34,.64),m)+u*.05;vec2 d=(uv-sp)*vec2(1.,1.35);float sun=exp(-dot(d,d)*3.4);' +
    'vec3 creme=vec3(.969,.945,.902);vec3 dawn=vec3(.86,.73,.48);vec3 day=vec3(.80,.68,.43);vec3 dusk=vec3(.57,.45,.26);' +
    'vec3 lc=m<.45?mix(dawn,day,m/.45):mix(day,dusk,(m-.45)/.55);' +
    'float amt=(.6*sun+.55*rd*sun)*g;vec3 c=mix(creme,lc,clamp(amt,0.,.17));o=vec4(c,1.);}';

  function shader(type, src) {
    var sh = gl.createShader(type);
    gl.shaderSource(sh, src); gl.compileShader(sh);
    if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) { return null; }
    return sh;
  }
  var vs = shader(gl.VERTEX_SHADER, VS), fs = shader(gl.FRAGMENT_SHADER, FS);
  if (!vs || !fs) { return; }
  var prog = gl.createProgram();
  gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { return; }
  gl.useProgram(prog);
  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, 'a');
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  var uR = gl.getUniformLocation(prog, 'r'), uT = gl.getUniformLocation(prog, 't'), uM = gl.getUniformLocation(prog, 'm'), uG = gl.getUniformLocation(prog, 'g'), uU = gl.getUniformLocation(prog, 'u');

  var small = window.matchMedia('(max-width: 40em)').matches;
  var scale = small ? 0.4 : 0.5;
  var fps = small ? 24 : 30;
  var w = 0, hgt = 0;
  function size() {
    var cw = holder.clientWidth || window.innerWidth, ch = holder.clientHeight || window.innerHeight;
    var nw = Math.max(1, Math.round(cw * scale)), nh = Math.max(1, Math.round(ch * scale));
    if (nw !== w || nh !== hgt) { w = nw; hgt = nh; canvas.width = w; canvas.height = hgt; gl.viewport(0, 0, w, hgt); }
  }

  /* the pointer nudges the light by a few percent; fingers do not */
  var px = 0, py = 0, tx = 0, ty = 0;
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    window.addEventListener('pointermove', function (e) {
      tx = (e.clientX / window.innerWidth - 0.5) * 2; ty = (0.5 - e.clientY / window.innerHeight) * 2;
    }, { passive: true });
  }
  var mood = (window.CHAREE && typeof window.CHAREE.mood === 'number') ? window.CHAREE.mood : 0.3;
  var target = mood;
  var gain = 0, gainTarget = 0.5;
  var t0 = performance.now(), last = 0, running = false, raf = 0;

  function draw(now) {
    gl.uniform2f(uR, w, hgt);
    gl.uniform1f(uT, (now - t0) / 1000);
    gl.uniform1f(uM, mood);
    gl.uniform1f(uG, gain);
    gl.uniform2f(uU, px, py);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
  }
  function frame(now) {
    raf = 0;
    if (!running) { return; }
    if (now - last >= 1000 / fps) {
      last = now;
      mood += (target - mood) * 0.03;
      gain += (gainTarget - gain) * 0.04;
      px += (tx - px) * 0.02; py += (ty - py) * 0.02;
      draw(now);
    }
    raf = window.requestAnimationFrame(frame);
  }
  function start() { if (running || reduceMotion) { return; } running = true; if (!raf) { raf = window.requestAnimationFrame(frame); } }
  function stop() { running = false; }

  document.documentElement.addEventListener('charee:light', function (e) {
    if (e.detail && typeof e.detail.mood === 'number') {
      target = e.detail.mood;
      if (reduceMotion) { mood = target; gain = gainTarget; draw(performance.now()); }
    }
  });
  document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
  window.addEventListener('resize', function () { size(); if (reduceMotion) { draw(performance.now()); } });
  canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); stop(); holder.classList.remove('has-canvas'); canvas.classList.remove('is-on'); });

  size();
  holder.classList.add('has-canvas');
  if (reduceMotion) { gain = gainTarget; draw(performance.now()); canvas.classList.add('is-on'); return; }
  draw(performance.now());
  canvas.classList.add('is-on');
  start();
})();
